import React from "react";
import { useParams } from "react-router-dom";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import PageContainer from "@/components/atoms/PageContainer";
import PageLayout from "@/components/templates/PageLayout";
import { NOTIFICATIONS_MESSAGES } from "@/messages/notifications/notifications.messages";
import useGetNotificationById from "@/hooks/requests/notification/use-get-notification-by-id";

const NotificationDetails: React.FC = () => {
  const { notificationId } = useParams();
  const { data: notification, isLoading, error } = useGetNotificationById(Number(notificationId));

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>Erro ao carregar notificação</div>;
  }

  if (!notification) {
    return <div>Notificação não encontrada</div>;
  }

  return (
    <PageLayout
      messages={NOTIFICATIONS_MESSAGES}
      title={NOTIFICATIONS_MESSAGES.notificationsPageTitle}
    >
      <PageContainer>
        <MDBox>
          <MDTypography variant="h4">{NOTIFICATIONS_MESSAGES.detailsDialogTitle}</MDTypography>
          <MDBox mt={2}>
            <MDTypography variant="body1">{notification.detail}</MDTypography>
          </MDBox>
        </MDBox>
      </PageContainer>
    </PageLayout>
  );
};

export default NotificationDetails;
